<ng-container *ngIf="porcentaje >75">
    <circle-progress [percent]="porcentaje" [radius]="radius" [outerStrokeColor]="'#78C000'"
      [outerStrokeGradient]="false" [outerStrokeWidth]="outerStrokeWidth" [innerStrokeWidth]="5" [space]="-4"
      [titleFontWeight]="600" [titleFontSize]="12"></circle-progress>
  </ng-container>
  <ng-container *ngIf="50< porcentaje && porcentaje <75">
    <circle-progress [percent]="porcentaje" [radius]="radius" [outerStrokeColor]="'#FDB900'"
      [outerStrokeGradient]="false" [outerStrokeWidth]="outerStrokeWidth" [innerStrokeWidth]="5" [space]="-4"
      [titleFontWeight]="600" [titleFontSize]="12"></circle-progress>
  </ng-container>
  <ng-container *ngIf="porcentaje <=50 && porcentaje>=0">
    <circle-progress [percent]="porcentaje" [radius]="radius" [outerStrokeColor]="'#FF6347'"
      [outerStrokeGradient]="false" [outerStrokeWidth]="outerStrokeWidth" [innerStrokeWidth]="5" [space]="-4"
      [titleFontWeight]="600" [titleFontSize]="12"></circle-progress>
  </ng-container>


  <div class="text-center" *ngIf="porcentaje < 0">
    <app-loading></app-loading>
  </div>